/* eslint-disable no-console, eslint-disable-line no-plusplus */
import { scrollToElement } from './scrolling-utils';

const formSelectors = 'input[type="text"], input[type="password"], textarea';

const validateByType = (type, val) => {
  // console.log(`${type}, ${val}`);
  let status;
  switch (type) {
    case 'text':
      status = val !== '';
      break;
    case 'phone':
      status = new RegExp(/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/).test(val);
      break;
    case 'zipcode':
      status = new RegExp(/(^\d{5}(-\d{4})?$)|(^[ABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Z]{1} *\d{1}[A-Z]{1}\d{1}$)/).test(val);
      break;
    case 'email':
      /* eslint-disable no-useless-escape */
      status = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/).test(val);
      /* eslint-enable no-useless-escape */
      break;
    case 'password':
      status = new RegExp(/^(?=.*[a-z])(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/).test(val); /* eslint-disable-line no-useless-escape */
      break;
    case 'productcode':
      // status = new RegExp(/^\d{7,8}[\.]\d{3}$/).test(val); /* eslint-disable-line no-useless-escape */
      // status = new RegExp(/^(\d{7,8}[\.]\d{3}$)|(^\d{7,8}$)/).test(val); /* eslint-disable-line no-useless-escape */
      status = new RegExp(/^(\d{1,}$)/).test(val); /* eslint-disable-line no-useless-escape */
      break;
    default:
      break;
  }
  return status;
};

// Format phone as xxx xxx xxxx
const formatPhone = (s) => {
  if (s !== null && s !== undefined && s !== '') {
    if (s.match(new RegExp(/\d/g) || []) !== null) {
      const arr = s.match(new RegExp(/\d/g) || []).join('');
      return `${arr.substring(0, 3)}-${arr.substring(3, 6)}-${arr.substring(6)}`;
    }
    return s;
  }
  return s;
};

const addFocusToErrorMessage = (element) => {
  // Scroll to message
  scrollToElement({
    element,
  });
  // Add focus
  element.focus();
};

const validate = (form) => {
  // Identify all fields with a validate attribute in form (will be on the label for the input/submit)
  const fieldList = form.querySelectorAll('[validate]');
  const fieldErrorList = [];
  let field;
  let isValid;
  let required;
  let isFormValid = true;
  for (let i = 0; i < fieldList.length; i++) { /* eslint-disable-line no-plusplus */
    field = fieldList[i];
    isValid = true;
    required = field.getAttribute('required') !== null;
    // If value is required, run against validation OR
    if (required) {
      isValid = validateByType(field.getAttribute('validate'), field.value);
    }
    // If value isn't required but value has been entered that requires validation, then run
    if (!required && field.value !== '' && field.getAttribute('validate') !== 'text') {
      isValid = validateByType(field.getAttribute('validate'), field.value);
    }
    // Mark field as invalid
    const fieldError = field.parentNode.querySelector('.text-danger');
    if (!isValid) {
      isFormValid = isValid;
      // Toggle error class on element label
      field.classList.add('input-validation-error');
      if (fieldError) {
        fieldError.classList.add('field-validation-error');
        fieldError.classList.remove('field-validation-valid');
        // Get error msg from input data attribute
        const errorMsg = field.getAttribute('data-val-required');
        fieldError.innerHTML = errorMsg;
      }
      fieldErrorList.push(field);
    } else {
      field.classList.remove('input-validation-error');
      if (fieldError) {
        fieldError.classList.remove('field-validation-error');
        fieldError.classList.add('field-validation-valid');
        fieldError.innerHTML = '';
      }
    }
  }
  // Form error message
  const errorMsg = form.querySelector('.form-error-message');
  if (isFormValid && errorMsg !== null) {
    errorMsg.classList.add('hidden');
  } else if (!isFormValid && errorMsg !== null) {
    errorMsg.classList.remove('hidden');
    // Add focus to error message, if form is invalid
    addFocusToErrorMessage(errorMsg);
  }
  return isFormValid;
};

const removeAllErrors = (form) => {
  const fieldList = form.querySelectorAll('[validate]');
  for (let i = 0; i < fieldList.length; i++) { /* eslint-disable-line no-plusplus */
    const field = fieldList[i];
    const fieldError = field.parentNode.querySelector('.text-danger');
    field.classList.remove('input-validation-error');
    if (fieldError) {
      fieldError.classList.remove('field-validation-error');
      fieldError.classList.add('field-validation-valid');
      fieldError.innerHTML = '';
    }
  }
};

const addRequiredAttrs = (form) => {
  const inputList = form.querySelectorAll(formSelectors);
  for (let i = 0; i < inputList.length; i++) { /* eslint-disable-line no-plusplus */
    inputList[i].setAttribute('required', 'required');
  }
};

const removeRequiredAttrs = (form) => {
  const inputList = form.querySelectorAll(formSelectors);
  for (let i = 0; i < inputList.length; i++) { /* eslint-disable-line no-plusplus */
    inputList[i].removeAttribute('required');
  }
};

const clearInputValues = (form) => {
  const inputList = form.querySelectorAll(formSelectors);
  for (let i = 0; i < inputList.length; i++) { /* eslint-disable-line no-plusplus */
    inputList[i].value = '';
  }
};

const resetSelectValues = (form) => {
  const selectList = form.querySelectorAll('select');
  for (let i = 0; i < selectList.length; i++) { /* eslint-disable-line no-plusplus */
    const select = selectList[i];
    const firstOption = select.querySelector('option:first-child');
    if (firstOption) {
      selectList[i].value = firstOption.value;
    }
  }
};

export {
  addRequiredAttrs,
  clearInputValues,
  validate,
  formatPhone,
  removeAllErrors,
  removeRequiredAttrs,
  resetSelectValues,
  validateByType,
};
/* eslint-enable no-console, eslint-disable-line no-plusplus */
